import AttributeFormModal from "./AttributeFormModal";

export default AttributeFormModal;
